import * as C from '../../actionTypes/discounts/detail'

export const retrieveDiscount = (payload) => ({type: C.RETRIEVE_DISCOUNT, payload })

export const listCustomers = () => ({ type: C.LIST_CUSTOMERS })
export const changeCustomersListPage = (payload) => ({ type: C.CHANGE_CUSTOMERS_LIST_PAGE, payload })

export const listRooms = () => ({ type: C.LIST_ROOMS })
export const changeRoomsListPage = (payload) => ({ type: C.CHANGE_ROOMS_LIST_PAGE, payload })
